// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container__af0 {
  width: 100%;
  height: calc(var(--ring-unit) * 10);
  box-sizing: border-box;
  position: relative;
  background: linear-gradient(
    160deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 1) 10%,
    rgba(70, 95, 243, 1) 100%
  );
  border-radius: calc(var(--ring-border-radius) * 2);
}

.container__af0 button {
  z-index: 10;

  & span:first-child {
    color: var(--ring-icon-white-color);
  }
}

.backgroundWrapper__c1b {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
}

.background__ff7 {
  position: relative;
  height: 100%;
  z-index: 1;
  right: 0;

  span {
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;

    svg {
      height: 100%;
      width: auto;
    }
  }
}

.textContainer__f97 {
  height: 100%;
  display: flex;
  padding: calc(var(--ring-unit) * 1.5) calc(var(--ring-unit) * 2.5);
  text-align: center;
  align-items: center;
  gap: calc(var(--ring-unit) * 4);

  > div {
    z-index: 2;
  }
}

.infoContainer__a37 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: calc(var(--ring-unit) * 0.5);
}

.titleContainer__f39 {
  display: flex;
  align-items: center;
  gap: calc(var(--ring-unit) * 1.5);

  h1 {
    margin: 0 0;
    color: var(--ring-icon-white-color);
  }
}

.linksContainer__c50 {
  display: flex;
  gap: calc(var(--ring-unit) * 2);
}

.logo__ef3 {
  height: calc(var(--ring-unit) * 4);
  filter: invert(100%) sepia(0%) saturate(1%) hue-rotate(145deg) brightness(200%) contrast(100%);
}

.text__e02 {
  color: var(--ring-icon-white-color);
}

.link__d83 {
  color: var(--ring-search-color);
}

@media (max-width: 1400px) {
  .container__af0 {
    height: calc(var(--ring-unit) * 15);
  }

  .textContainer__f97 {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--ring-unit);
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/ai/enable-ai-banner/enable-ai-banner.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mCAAmC;EACnC,sBAAsB;EACtB,kBAAkB;EAClB;;;;;GAKC;EACD,kDAAkD;AACpD;;AAEA;EACE,WAAW;;EAEX;IACE,mCAAmC;EACrC;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,QAAQ;;EAER;IACE,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,QAAQ;;IAER;MACE,YAAY;MACZ,WAAW;IACb;EACF;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kEAAkE;EAClE,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;;EAE/B;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iCAAiC;;EAEjC;IACE,WAAW;IACX,mCAAmC;EACrC;AACF;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,8FAA8F;AAChG;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,mCAAmC;EACrC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;EACvB;AACF","sourcesContent":[".container {\n  width: 100%;\n  height: calc(var(--ring-unit) * 10);\n  box-sizing: border-box;\n  position: relative;\n  background: linear-gradient(\n    160deg,\n    rgba(0, 0, 0, 1) 0%,\n    rgba(0, 0, 0, 1) 10%,\n    rgba(70, 95, 243, 1) 100%\n  );\n  border-radius: calc(var(--ring-border-radius) * 2);\n}\n\n.container button {\n  z-index: 10;\n\n  & span:first-child {\n    color: var(--ring-icon-white-color);\n  }\n}\n\n.backgroundWrapper {\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n}\n\n.background {\n  position: relative;\n  height: 100%;\n  z-index: 1;\n  right: 0;\n\n  span {\n    height: 100%;\n    position: absolute;\n    top: 0;\n    right: 0;\n\n    svg {\n      height: 100%;\n      width: auto;\n    }\n  }\n}\n\n.textContainer {\n  height: 100%;\n  display: flex;\n  padding: calc(var(--ring-unit) * 1.5) calc(var(--ring-unit) * 2.5);\n  text-align: center;\n  align-items: center;\n  gap: calc(var(--ring-unit) * 4);\n\n  > div {\n    z-index: 2;\n  }\n}\n\n.infoContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: calc(var(--ring-unit) * 0.5);\n}\n\n.titleContainer {\n  display: flex;\n  align-items: center;\n  gap: calc(var(--ring-unit) * 1.5);\n\n  h1 {\n    margin: 0 0;\n    color: var(--ring-icon-white-color);\n  }\n}\n\n.linksContainer {\n  display: flex;\n  gap: calc(var(--ring-unit) * 2);\n}\n\n.logo {\n  height: calc(var(--ring-unit) * 4);\n  filter: invert(100%) sepia(0%) saturate(1%) hue-rotate(145deg) brightness(200%) contrast(100%);\n}\n\n.text {\n  color: var(--ring-icon-white-color);\n}\n\n.link {\n  color: var(--ring-search-color);\n}\n\n@media (max-width: 1400px) {\n  .container {\n    height: calc(var(--ring-unit) * 15);\n  }\n\n  .textContainer {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--ring-unit);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container__af0`,
	"backgroundWrapper": `backgroundWrapper__c1b`,
	"background": `background__ff7`,
	"textContainer": `textContainer__f97`,
	"infoContainer": `infoContainer__a37`,
	"titleContainer": `titleContainer__f39`,
	"linksContainer": `linksContainer__c50`,
	"logo": `logo__ef3`,
	"text": `text__e02`,
	"link": `link__d83`
};
export default ___CSS_LOADER_EXPORT___;
